var map = {
	"./AntMall/AntMalllogo.svg": 17208,
	"./AntMall/logo.svg": 62869,
	"./AntMall/shoplogo.svg": 80865,
	"./Argos/Argoslogo.svg": 67108,
	"./Argos/logo.svg": 28156,
	"./Argos/shoplogo.svg": 42888,
	"./ArgosShop/ArgosShoplogo.svg": 7076,
	"./ArgosShop/logo.svg": 16064,
	"./ArgosShop/shoplogo.svg": 42388,
	"./EShop/EShoplogo.svg": 47928,
	"./EShop/logo.svg": 52801,
	"./EShop/shoplogo.svg": 61621,
	"./FamilyMart/FamilyMartlogo.svg": 83590,
	"./FamilyMart/logo.svg": 45186,
	"./FamilyMart/shoplogo.svg": 80190,
	"./FamilyShop/FamilyShoplogo.svg": 61410,
	"./FamilyShop/logo.svg": 93970,
	"./FamilyShop/shoplogo.svg": 34638,
	"./GreenMall/GreenMalllogo.svg": 62460,
	"./GreenMall/logo.svg": 75887,
	"./GreenMall/shoplogo.svg": 40523,
	"./Hive/Hivelogo.svg": 22614,
	"./Hive/logo.svg": 26220,
	"./Hive/shoplogo.svg": 65240,
	"./INT Overstock/INT Overstocklogo.svg": 28472,
	"./INT Overstock/logo.svg": 2295,
	"./INT Overstock/shoplogo.svg": 22003,
	"./Iceland/Icelandlogo.svg": 24404,
	"./Iceland/logo.svg": 44984,
	"./Iceland/shoplogo.svg": 54316,
	"./Inchoi/Inchoilogo.svg": 36518,
	"./Inchoi/logo.svg": 97246,
	"./Inchoi/shoplogo.svg": 13650,
	"./Just Shop/Just Shoplogo.svg": 16644,
	"./Just Shop/logo.svg": 59852,
	"./Just Shop/shoplogo.svg": 10296,
	"./Laz/Lazlogo.svg": 97304,
	"./Laz/logo.svg": 50541,
	"./Laz/shoplogo.svg": 52569,
	"./Mbuy/Mbuylogo.svg": 36232,
	"./Mbuy/logo.svg": 80243,
	"./Mbuy/shoplogo.svg": 92311,
	"./MetaShop/MetaShoplogo.svg": 67164,
	"./MetaShop/logo.svg": 82631,
	"./MetaShop/shoplogo.svg": 47875,
	"./SM-wholesale shop/SM-wholesale shoplogo.svg": 37472,
	"./SM-wholesale shop/logo.svg": 6521,
	"./SM-wholesale shop/shoplogo.svg": 36525,
	"./Shop2u/Shop2ulogo.svg": 42320,
	"./Shop2u/logo.svg": 29963,
	"./Shop2u/shoplogo.svg": 9647,
	"./Shopee/Shopeelogo.svg": 57470,
	"./Shopee/logo.svg": 37608,
	"./Shopee/shoplogo.svg": 4444,
	"./TikTok-Wholesale/TikTok-Wholesalelogo.svg": 91000,
	"./TikTok-Wholesale/logo.svg": 3853,
	"./TikTok-Wholesale/shoplogo.svg": 21017,
	"./Tongda/Tongdalogo.svg": 75168,
	"./Tongda/logo.svg": 72291,
	"./Tongda/shoplogo.svg": 79431,
	"./Zalando/Zalandologo.svg": 33260,
	"./Zalando/logo.svg": 91087,
	"./Zalando/shoplogo.svg": 65611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16848;